/* istanbul ignore file */

import { Configuration, PopupRequest } from '@azure/msal-browser';

const {
  REACT_APP_AUTH_AUTHORITY,
  REACT_APP_AUTH_CLIENT_ID,
  REACT_APP_AUTH_API_SCOPE,
  REACT_APP_AUTH_REDIRECT_URL
} = process.env as { [prop: string]: string };

const redirectUri: string = `${window.location.origin}${REACT_APP_AUTH_REDIRECT_URL}`;

const msalConfig: Configuration = {
  auth: {
    authority: REACT_APP_AUTH_AUTHORITY,
    clientId: REACT_APP_AUTH_CLIENT_ID,
    redirectUri,
    navigateToLoginRequestUrl: true,
    postLogoutRedirectUri: redirectUri
  }
};

const loginRequest: PopupRequest = {
  scopes: ['openid', REACT_APP_AUTH_API_SCOPE as string]
};

export const authConfig = {
  msalConfig,
  loginRequest
};
